/// <amd-module name="Release/Landing/HubContent/Releases/ActiveReleasesActions" />
import { Release, EnvironmentStatus, DeploymentStatus, DeploymentOperationStatus, ReleaseEnvironment } from "Release/Client/Contracts/Release";
import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";
import { IReleasesFilterState } from "Release/Landing/HubContent/Filter/FilterTypes";

export interface IActiveReleasesPayload {
    definitionId: number;
    folderPath: string;
    releases: Release[];
    continuationToken: number;
    filterState?: IReleasesFilterState
    definitionEnvironmentCurrentReleaseMap: { [key: number]: number } | undefined | null;
    isLoading: boolean;
}

export interface IUpdateReleasePayload {
    release: Release;
}

export interface IRemoveReleasePayload {
    releaseId: number;
}

export interface IActiveReleasesColumnPayload {
    definitionId: number;
    newWidth: number;
}

export interface IActiveReleasesColumnOptionsPayload {
    definitionId: number;
    folderPath: string;
    visibleColumns: string[];
}

export interface IUpdateReleaseEnvironmentStatusPayload {
    definitionId: number;
    releaseId: number;
    environmentId: number;
    environmentStatus: EnvironmentStatus;
    deploymentStatus: DeploymentStatus;
    operationStatus: DeploymentOperationStatus;
}

export interface IStartedReleaseEnvironmentPayload {
    environment: ReleaseEnvironment;
    definitionId: number;
    updateOnlyNotDeployed: boolean;
}

export class ActiveReleasesActions extends ActionsHubBase {
    public static getKey(): string {
        return "release-landing-active-releases-actions";
    }

    public initialize(): void {
        this._releasesUpdated = new Action<IActiveReleasesPayload>();
        this._releasesUpdatedWithMore = new Action<IActiveReleasesPayload>();
        this._setCurrentlyDeployedState = new Action<boolean>();
        this._updateRelease = new Action<IUpdateReleasePayload>();
        this._removeRelease = new Action<IRemoveReleasePayload>();
        this._clearReleases = new Action<any>();
        this._onEnvironmentColumnResize = new Action<IActiveReleasesColumnPayload>();
        this._onReleaseColumnResize = new Action<IActiveReleasesColumnPayload>();
        this._releaseCreated = new Action<IUpdateReleasePayload>();
        this._setColumnOptions = new Action<IActiveReleasesColumnOptionsPayload>();
        this._clearApprovalsBar = new Action<{}>();
        this._releaseFocused = new Action<number>();
        this._releaseHovered = new Action<number>();
        this._updateReleaseEnvironmentStatus = new Action<IUpdateReleaseEnvironmentStatusPayload>();
        this._handleFetchedReleaseEnvironment = new Action<IStartedReleaseEnvironmentPayload>();
    }

    public get releasesUpdated(): Action<IActiveReleasesPayload> {
        return this._releasesUpdated;
    }

    public get releasesUpdatedWithMore(): Action<IActiveReleasesPayload> {
        return this._releasesUpdatedWithMore;
    }

    public get updateRelease(): Action<IUpdateReleasePayload> {
        return this._updateRelease;
    }

    public get removeRelease(): Action<IRemoveReleasePayload> {
        return this._removeRelease;
    }

    public get clearReleases(): Action<any> {
        return this._clearReleases;
    }

    public get onEnvironmentColumnResize(): Action<IActiveReleasesColumnPayload> {
        return this._onEnvironmentColumnResize;
    }

    public get onReleaseColumnResize(): Action<IActiveReleasesColumnPayload> {
        return this._onReleaseColumnResize;
    }

    public get releaseCreated(): Action<IUpdateReleasePayload> {
        return this._releaseCreated;
    }

    public get setColumnOptions(): Action<IActiveReleasesColumnOptionsPayload> {
        return this._setColumnOptions;
    }

    public get clearApprovalsBar(): Action<{}> {
        return this._clearApprovalsBar;
    }

    public get releaseFocused(): Action<number> {
        return this._releaseFocused;
    }

    public get releaseHovered(): Action<number> {
        return this._releaseHovered;
    }

    public get updateReleaseEnvironmentStatus(): Action<IUpdateReleaseEnvironmentStatusPayload> {
        return this._updateReleaseEnvironmentStatus;
    }

    public get handleFetchedReleaseEnvironment(): Action<IStartedReleaseEnvironmentPayload> {
        return this._handleFetchedReleaseEnvironment;
    }

    private _releasesUpdated: Action<IActiveReleasesPayload>;
    private _releasesUpdatedWithMore: Action<IActiveReleasesPayload>;
    private _updateRelease: Action<IUpdateReleasePayload>;
    private _removeRelease: Action<IRemoveReleasePayload>;
    private _setCurrentlyDeployedState: Action<boolean>;
    private _clearReleases: Action<any>;
    private _onEnvironmentColumnResize: Action<IActiveReleasesColumnPayload>;
    private _onReleaseColumnResize: Action<IActiveReleasesColumnPayload>;
    private _releaseCreated: Action<IUpdateReleasePayload>;
    private _setColumnOptions: Action<IActiveReleasesColumnOptionsPayload>;
    private _clearApprovalsBar: Action<{}>;
    private _releaseFocused: Action<number>;
    private _releaseHovered: Action<number>;
    private _updateReleaseEnvironmentStatus: Action<IUpdateReleaseEnvironmentStatusPayload>;
    private _handleFetchedReleaseEnvironment: Action<IStartedReleaseEnvironmentPayload>;
}
